/**
 * GCS website hosting redirects /path → /path/index.html for prerendered
 * folders. React Router routes are /path (and /news/:slug must not treat
 * "index.html" as a slug). Run this module before createBrowserRouter so the
 * history is created from the cleaned pathname.
 */
const GCS_INDEX_SUFFIX = '/index.html'

if (typeof window !== 'undefined' && window.location.pathname.endsWith(GCS_INDEX_SUFFIX)) {
  const cleaned = window.location.pathname.slice(0, -GCS_INDEX_SUFFIX.length) || '/'
  window.history.replaceState(
    null,
    '',
    `${cleaned}${window.location.search}${window.location.hash}`,
  )
}
